import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a9d1cee"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subject-header"
}, null, -1));
const _hoisted_2 = {
  class: "subject-content"
};
const _hoisted_3 = {
  class: "content-left"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "item-txt"
};
const _hoisted_6 = {
  class: "contetn-right"
};
const _hoisted_7 = ["id"];
const _hoisted_8 = {
  key: 0,
  class: "content-item"
};
const _hoisted_9 = {
  class: "item-header"
};
const _hoisted_10 = {
  class: "item-list-content"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = {
  class: "item-img"
};
const _hoisted_13 = ["src", "alt"];
const _hoisted_14 = {
  class: "item-info"
};
const _hoisted_15 = {
  class: "info-name"
};
const _hoisted_16 = {
  class: "info-brief"
};
const _hoisted_17 = {
  key: 1,
  class: "platfomr-none"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_update_time = _resolveComponent("update-time");
  const _component_t_layout = _resolveComponent("t-layout");
  return _openBlock(), _createBlock(_component_t_layout, {
    class: "subject"
  }, {
    default: _withCtx(() => [_hoisted_1, _createElementVNode("section", _hoisted_2, [_createVNode(_component_update_time), _ctx.subjectContentItems && _ctx.subjectContentItems.length && !_ctx.objNull ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectContentItems, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: item.key,
        class: _normalizeClass(['left-item', {
          'is-select': _ctx.activeIndex[index]
        }]),
        onClick: $event => _ctx.handleClickNav(item, index)
      }, [item.list.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.name), 1)) : _createCommentVNode("", true)], 10, _hoisted_4);
    }), 128))]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectContentItems, contentItem => {
      return _openBlock(), _createElementBlock("div", {
        id: contentItem.key,
        key: contentItem.key
      }, [contentItem.list.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(contentItem.name), 1), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contentItem.list, item => {
        return _openBlock(), _createElementBlock("a", {
          key: item.name,
          class: "list-item",
          target: "_blank",
          href: `/subject/detail/${item.name}`
        }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
          src: item.general_image,
          alt: item.name
        }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(item.brief), 1)])], 8, _hoisted_11);
      }), 128))])])) : _createCommentVNode("", true)], 8, _hoisted_7);
    }), 128))])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_17, "信息建设中，敬请期待..."))])]),
    _: 1
  });
}